<template>
  <div class="version-maintenance-container">
    <div class="version-maintenance">
      <div style="text-align: left">
        <div class="textContent">
          <div class="testcontent">
            <div class="textDescription">
              <div>Dear Golden PIPE user</div>
              <h6>
                为提供更多新功能以及更优质的服务，我们将于{{
                  startTime
                }}至{{ endTime }}对Golden
                Pipe系统进行版本升级维护。
                升级期间系统将不可用，为避免影响您的操作以及数据,
                请错开升级时间使用系统.
                <br />
                <br />
                以上给大家带来的不便，敬请谅解！感谢各位的理解和一直以来的支持，祝您生活愉快。
                如有疑问,可以通过如下方式联系我们.
              </h6>
              <br />
              <div>
                <h6>Hotline Number: 4001001751 转 5</h6>
                <h6>Email: goldenpipe.im@pg.com</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import maintenanceUrl from "@/url.js";

export default {
  name: "switchRole",
  props: {},

  components: {},
  data() {
    return {
      yearMouthDay: "",
      startTime: "",
      endTime: "",
    };
  },
  created() {
    this.maintencePageContent();
  },
  methods: {
    maintencePageContent() {
      let that = this;
      let url = this.baseUrl + maintenanceUrl.versionMaintenanceUrl;
      this.http
        .get(url)
        .then((resp) => {
          let data = resp.data;
          // console.log(data)
          let maintenceThings = data.basicSystemMaintenanceDO;
          // console.log(maintenceThings.id)
          that.startTime = maintenceThings.maintenanceStart;
          that.endTime = maintenceThings.maintenanceEnd;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>


<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.textDescription {
  width: 455px;
}
.testcontent {
  padding-top: 10px;
  margin-top: 80px;
  padding-left: 35px;
  width: 520px;
  height: 300px;
}

.textContent {
  padding: 0;
  margin: 0;
  z-index: 10000;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(../assets/images/version_maintence_Icon.png);
  background-repeat: no-repeat;
  overflow: hidden;
}
.version-maintenance-container {
  z-index: 10000;
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  background-position: 50%;
  background-color: #000000;
  background-image: url(../assets/images/version_maintence_background.png);
  background-repeat: no-repeat;
  background-size: contain;
  min-width: 1150px;
  overflow: hidden;
}

.version-maintenance {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 300px;
  border: 1px;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/view/version_maintenance.vue